import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import Select from "react-select"; 
import { useNavigate } from "react-router-dom";   // 🔹 ADD THIS

export const Searchjob = () => {
  const navigate = useNavigate();  // 🔹 INIT

  const getTimeAgo = (createdAt) => {
    const createdDate = new Date(createdAt);
    const now = new Date();
    const diffInSeconds = Math.floor((now - createdDate) / 1000);

    if (diffInSeconds < 60) {
      return `Added: ${diffInSeconds} seconds ago`;
    } else if (diffInSeconds < 3600) {
      const mins = Math.floor(diffInSeconds / 60);
      return `Added: ${mins} min${mins > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 86400) {
      const hrs = Math.floor(diffInSeconds / 3600);
      return `Added: ${hrs} hour${hrs > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 2592000) {
      const days = Math.floor(diffInSeconds / 86400);
      return `Added: ${days} day${days > 1 ? 's' : ''} ago`;
    } else if (diffInSeconds < 31536000) {
      const months = Math.floor(diffInSeconds / 2592000);
      return `Added: ${months} month${months > 1 ? 's' : ''} ago`;
    } else {
      const years = Math.floor(diffInSeconds / 31536000);
      return `Added: ${years} year${years > 1 ? 's' : ''} ago`;
    }
  };

  const [background6, setBackground6] = useState("");
  const [vacancies, setVacancies] = useState([]);
  const [filteredVacancies, setFilteredVacancies] = useState([]);

  const [countries, setCountries] = useState([]);
  const [industryTypes, setIndustryTypes] = useState([]);

  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);

  const [positionDetail, setPositionDetail] = useState("");
  const [masterAgentCode, setMasterAgentCode] = useState("");
  const [selectedVacancyId, setSelectedVacancyId] = useState(null);
  const [positionOptions, setPositionOptions] = useState([]);
  const [selectedPositions, setSelectedPositions] = useState([]);

  useEffect(() => {
    fetch("https://goforen.com/go_foren/get_unique_positions/")
      .then(res => res.json())
      .then(data => {
        const formattedOptions = [
          { value: 'any', label: 'Any Position' },
          ...data.map(pos => ({
            value: pos,
            label: pos
          }))
        ];
        setPositionOptions(formattedOptions);
      })
      .catch(err => console.error("Failed to load job positions", err));
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [applyData, setApplyData] = useState({
    name: "",
    number: "",
    email: "",
  });

  useEffect(() => {
    fetch("https://goforen.com/go_foren/get_Industry_Type_data/")
      .then(res => res.json())
      .then(data => setIndustryTypes(data))
      .catch(err => console.error("Failed to load industry types", err));

    fetch("https://goforen.com/go_foren/get_career_country_data/")
      .then(res => res.json())
      .then(data => setCountries(data))
      .catch(err => console.error("Failed to load countries", err));
  }, []);

  useEffect(() => {
    fetch("https://goforen.com/go_foren/get_Vacancy_data/")
      .then((response) => response.json())
      .then((data) => {
        setVacancies(data);
        setFilteredVacancies(data);
      })
      .catch((error) => console.error("Error fetching vacancies:", error));
  }, []);

  useEffect(() => {
    setBackground6("/assets/pic/inquiry.png");
  }, []);

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', options).replace(/ /g, ' ').replace(',', ',');
  };

  const countryOptions = [
    { value: 'anywhere', label: 'Anywhere' },
    ...countries.map(c => ({ value: c.country, label: c.country })),
  ];

  const industryOptions = [
    { value: 'any', label: 'Any Industry Type' },
    ...industryTypes.map(i => ({
      value: i.industry_name,
      label: i.industry_name,
    }))
  ];

  const handleFilter = () => {
    const selectedCountryValues = selectedCountries.map(c => c.value);
    const selectedIndustryValues = selectedIndustries.map(i => i.value);
    const selectedPositionValues = selectedPositions.map(p => p.value.toLowerCase());

    const isCountryAny = selectedCountryValues.includes('anywhere');
    const isIndustryAny = selectedIndustryValues.includes('any');
    const isPositionAny = selectedPositionValues.includes('any');

    const filtered = vacancies.filter(job => {
      const countryMatch = isCountryAny || selectedCountryValues.length === 0
        ? true
        : selectedCountryValues.some(country =>
          job.location.toLowerCase().includes(country.toLowerCase())
        );

      const industryMatch = isIndustryAny || selectedIndustryValues.length === 0
        ? true
        : selectedIndustryValues.includes(job.industry_type);

      const masterAgentMatch = masterAgentCode
        ? job.master_agent_code?.toString().includes(masterAgentCode)
        : true;

      const positionMatch = isPositionAny || selectedPositionValues.length === 0
        ? true
        : selectedPositionValues.some(pos =>
          job.position_name.toLowerCase().includes(pos)
        );

      return countryMatch && industryMatch && positionMatch && masterAgentMatch;
    });

    setFilteredVacancies(filtered);
    setFilterApplied(true);
  };

  const handleReset = () => {
    setSelectedCountries([]);
    setSelectedIndustries([]);
    setPositionDetail("");
    setMasterAgentCode("");
    setFilteredVacancies(vacancies);
    setSelectedPositions([]);
    setFilterApplied(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "number") {
      const onlyDigits = value.replace(/\D/g, "");
      if (onlyDigits.length <= 10) {
        setApplyData({ ...applyData, [name]: onlyDigits });
      }
    } else if (name === "name") {
      if (/^[a-zA-Z\s]*$/.test(value)) {
        setApplyData({ ...applyData, [name]: value });
      }
    } else {
      setApplyData({ ...applyData, [name]: value });
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      vacancy_id: selectedVacancyId,
      name: applyData.name,
      mobile: applyData.number,
      email: applyData.email,
    };

    try {
      const response = await fetch("https://goforen.com/go_foren/submit_vacancy_inquiry/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Application Submitted!",
          text: "Thank you for applying. We will contact you shortly.",
          confirmButtonColor: "#e38508"
        });
        setShowModal(false);
        setApplyData({ name: "", number: "", email: "" });
        setSelectedVacancyId(null);
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.error || "Please try again later.",
          confirmButtonColor: "#e38508"
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Network error. Please try again later.",
        confirmButtonColor: "#e38508"
      });
    }
  };

  // 🔹 Redirect handler
  const handleViewMore = () => {
    navigate("/Vacancies");
  };

  return (
    <>
      <section className='pt-60 pb-60' style={{ backgroundColor: '#edf3f57a' }}>
        <div className="container">
          <h2 style={{marginBottom:'15px'}}>Vacancies</h2>
          
          <div className="vacancy-formv">
            <Select isMulti options={countryOptions} value={selectedCountries} onChange={setSelectedCountries} placeholder="Select Country" className='searchjobfeild'/>
            <Select isMulti options={industryOptions} value={selectedIndustries} onChange={setSelectedIndustries} placeholder="Select Industry Type" className='searchjobfeild'/>
            <Select isMulti options={positionOptions} value={selectedPositions} onChange={setSelectedPositions} placeholder="Select Job Position / Title" className='searchjobfeild'/>

            <input hidden type="number" placeholder="Master Agent - Code" value={masterAgentCode} onChange={(e) => setMasterAgentCode(e.target.value)} />
            <button className="submit-btnv" onClick={handleFilter}>Submit</button>
            <button className="reset-btnv" onClick={handleReset}>Reset</button>
          </div>

          <div className="row">
            <div className="col-md-12">
              <ul className="job-listv">
                {!filterApplied ? (
                  <li className="text-center" style={{ padding: "20px", color: "#777", fontSize: "18px" }}>
                    Search for the vacancies.
                  </li>
                ) : filteredVacancies.length === 0 ? (
                  <li className="text-center" style={{ padding: "20px", color: "#777", fontSize: "18px" }}>
                    No results found for this search.
                  </li>
                ) : (
                  filteredVacancies
                    .filter((job) => new Date(job.expiry_date) >= new Date())
                    .slice(0, 2)  
                    .map((job, index) => (
                      <li className="job-previewv" key={index}>
                        <div className="col-md-1 col-12 d-flex flex-column justify-content-center align-items-center">
                          <li style={{ color: "#07374d" }}>
                            <i className="fas fa-map-marker-alt"></i> {job.location}
                          </li>
                        </div>
                        <div className="col-md-2 col-12 d-flex flex-column justify-content-center align-items-center">
                          <li style={{ marginRight: "10px", color: "#e38508" }}>
                            <i className="fas fa-building"></i> {job.industry_type}
                          </li>
                        </div>
                        <div className="col-md-1 col-12 d-flex flex-column justify-content-center align-items-center">
                          <h4 className="job-titlev text-center">{job.master_agent_code}</h4>
                        </div>
                        <div className="col-md-4 col-12 d-flex flex-column justify-content-center align-items-center">
                          <h4 className="job-titlev text-center">{job.position_name}</h4>
                        </div>
                        <div className="col-md-2 col-12 d-flex flex-column justify-content-center align-items-center">
                          <p className="job-titlev text-center">{formatDate(job.vacancy_date)}</p>
                          <p className="ej-list-subv text-center">No of vacancies: {job.vacancy_count}</p>
                        </div>
                        <div className="col-md-2 col-12 d-flex justify-content-center align-items-center flex-column">
                          <button
                            onClick={() => {
                              setSelectedVacancyId(job.id);
                              setShowModal(true);
                            }}
                            className="btnv btn-applyv float-sm-rightv float-xs-leftv"
                          >
                            Inquiry
                          </button>
                          <span className="text-muted mt-2" style={{ fontSize: "12px" }}>
                            {getTimeAgo(job.created_at)}
                          </span>
                        </div>
                      </li>
                    ))
                )}
              </ul>

              {/* 🔹 VIEW MORE BUTTON */}
              {filterApplied && filteredVacancies.length > 2 && (
                <div style={{ justifyContent: "center", display: "flex", marginTop: "30px" }}>
                  <button
                    onClick={handleViewMore}
                    style={{
                      padding: "10px 20px",
                      background: "#e38508",
                      borderRadius: "10px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <span style={{ color: "#fff" }}>View More</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 Inquiry Modal (same as before) */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '30px',
            borderRadius: '10px',
            width: '90%',
            maxWidth: '500px',
            position: 'relative'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <h3>Inquire Now</h3>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#999'
                }}
              >&times;</button>
            </div>
            <form onSubmit={handleFormSubmit}>
              <input type="text" name="name" placeholder="Name" value={applyData.name} onChange={handleInputChange} required style={inputStyle} />
              <input type="text" name="number" placeholder="Whatsapp Number" value={applyData.number} onChange={handleInputChange} required style={inputStyle} />
              <input type="email" name="email" placeholder="Email" value={applyData.email} onChange={handleInputChange} required style={inputStyle} />
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#e38508",
                    color: "#fff",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "5px",
                  }}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

const inputStyle = {
  width: '100%',
  marginBottom: '15px',
  padding: '10px',
  border: '1px solid #ccc',
  borderRadius: '5px'
};
